<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5>{{ $t("assign_form") }}</h5>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form ref="form" class="mb-0" :class="{ 'loading-opacity': preloader }">
        <div class="form-group">
          <label>{{ $t("forms") }}</label>
          <app-input
            type="multi-select"
            :isAnimatedDropdown="true"
            :placeholder="$t('forms')"
            :list="forms"
            v-model="inputs.form_id"
            :required="true"
          />
          <p class="font-italic text-muted mb-0">
            Assign document templates or folders from the document library to this package.
          </p>
          <p class="font-italic text-muted">
            <a href="#" @click.prevent="openDocuments">{{ $t("create_new") }}</a>
            <span> in Document Library</span>
          </p>
        </div>
      </form>
    </template>
    <template slot="footer">
      <button class="btn btn-secondary mr-2" @click="closeModal">{{ $t("cancel") }}</button>
      <button class="btn btn-primary" @click.prevent="submit">{{ $t("save") }}</button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import {
  PACKAGE_FORM_ASSIGN,
  PACKAGE_FORM_TEMPLATE_OPTIONS,
} from "../../../../Config/ApiUrl";

export default {
  name: "PackageTemplateAssignModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      modalId: "package-form-assign-Modal",
      preloader: false,
      forms: [],
      inputs: {
        form_id: [],
      },
    };
  },
  methods: {
    getTemplateOptions() {
      this.preloader = true;
      axiosGet(PACKAGE_FORM_TEMPLATE_OPTIONS)
        .then((res) => {
          this.forms = res.data || [];
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    submit() {
      this.preloader = true;
      axiosPost(PACKAGE_FORM_ASSIGN, {
        ...this.inputs,
        package_id: this.id,
      })
        .then((response) => {
          this.$toastr.s(response.data.message);
          this.$hub.$emit("reload-advance-table");
          this.closeModal();
        })
        .catch((error) => {
          this.$toastr.e(error?.response?.data?.message || error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    openDocuments() {
      window.open("/admin/documentlibrary/mydocument", "_blank");
    },
  },
  mounted() {
    this.getTemplateOptions();
  },
};
</script>

<style scoped>
:deep(#package-form-assign-Modal .modal-dialog) {
  max-width: 96vw;
  width: 96vw;
  margin: 1rem auto;
}

:deep(#package-form-assign-Modal .modal-body) {
  min-height: 70vh;
  max-height: none;
  overflow-y: visible;
}

:deep(#package-form-assign-Modal .modal-content) {
  overflow: visible;
}

:deep(#package-form-assign-Modal .v-select-page),
:deep(#package-form-assign-Modal .dropdown-menu) {
  max-height: 320px;
}
</style>
